import React, { Component } from "react";
import "./App.css";
import image1 from "./images/andamanda_screen_saver_bg_1.png";
import image2 from "./images/andamanda_screen_saver_bg_2.png";
import image3 from "./images/andamanda_screen_saver_bg_3.png";
import shadow from "./images/shadow.png";
import scan from "./images/scan.png";
import thaiFlag from "./images/thai_flag.png";
import thaiFlagGrey from "./images/thai_flag_grey.png";
import engFlag from "./images/eng_flag.png";
import engFlagGrey from "./images/eng_flag_grey.png";
// Slide
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
// Change language
import PropTypes from "prop-types";
import en from "./languages/en.json";
import th from "./languages/th.json";
// Open new page
import { Link } from "react-router-dom";
// Translation Higher Order Component
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from "react-switch-lang";

// Do this two lines only when setting up the application
setTranslations({ en, th });
setDefaultLanguage("th");

// If you want to remember selected language
setLanguageCookie();

const apiUrl =
  "https://centapi.andamandaphuket.com:8443/centaman.api/v3/giftcards?GiftcardNo=";

class App extends Component {
  constructor() {
    super();
    this.slideRef = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      current: 0,
      language: "th",
      wristband: "",
      languageStatus: "th",
    };
  }

  mockupUserDetail(value) {
    this.wristbandInput.value = "";
    this.setState({ wristband: "" });
    this.props.history.push({
      pathname: "/page3",
      state: {
        giftcardNo: value,
        totalBalance: "No Balance",
      },
    });
  }

  // getUserDetail = async (wristband) => {
  //   //call api
  //   try {
  //     const response = await fetch(apiUrl + wristband, {
  //       method: "GET",
  //       headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
  //     });
  //     const result = await response.json();
  //     const userDetail = result[0];
  //     if (userDetail) {
  //       //3322780051
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //       this.props.history.push({
  //         pathname: "/page3",
  //         state: {
  //           giftcardNo: userDetail.GiftcardNo,
  //           giftcardExpiryDate: userDetail.GiftcardExpiryDate,
  //           cashOutBalance: userDetail.CashOutBalance,
  //           restrictedBalance: userDetail.RestrictedBalance,
  //           totalBalance: userDetail.TotalBalance,
  //         },
  //       });
  //     } else {
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //     }
  //   } catch (error) {
  //     this.wristbandInput.value = "";
  //     this.setState({ wristband: "" });
  //     this.props.history.push({
  //       pathname: "/page5",
  //       state: {
  //         wristband: wristband,
  //       },
  //     });
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  getUserDetail = (wristband) => {
    return new Promise((resolve, reject) => {
      fetch(apiUrl + parseInt(wristband), {
        method: "GET",
        headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
      })
        .then((response) => response.json())
        .then((result) => {
          const userDetail = result[0];

          if (userDetail) {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });

            const stateData = {
              giftcardNo: userDetail.GiftcardNo,
              giftcardExpiryDate: userDetail.GiftcardExpiryDate,
              cashOutBalance: userDetail.CashOutBalance,
              restrictedBalance: userDetail.RestrictedBalance,
              totalBalance: userDetail.TotalBalance,
            };

            this.props.history.push({
              pathname: "/page3",
              state: stateData,
            });

            resolve(stateData);
          } else {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });
            resolve(null); // Resolve with null to indicate no user detail
          }
        })
        .catch((error) => {
          this.wristbandInput.value = "";
          this.setState({ wristband: "" });

          this.props.history.push({
            pathname: "/page5",
            state: {
              wristband: wristband,
            },
          });

          reject(error); // Reject with the error
        })
        .finally(() => {
          // setLoading(false);
        });
    });
  };

  componentDidMount() {
    console.log("Component did mount...");
    this.wristbandInput.focus();
  }

  handleChange(value) {
    if (value !== this.state.languageStatus) {
      setLanguage(value);
      this.setState({ language: value });
      this.wristbandInput.focus();
    }
  }

  handleWristbandKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState({ wristband: e.target.value });
      this.getUserDetail(e.target.value)
        .then((stateData) => {
          if (stateData === null) {
            // Handle case where no user detail was found
            console.log("No user detail found");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  render() {
    const { t } = this.props;
    const properties = {
      duration: 45000,
      autoplay: true,
      transitionDuration: 500,
      arrows: false,
      infinite: true,
      easing: "ease",
      canSwipe: false,
    };
    const slideImages = [image1, image2, image3];
    return (
      <div className="App" onClick={() => this.wristbandInput.focus()}>
        <img
          alt="thai-info"
          className="thaiImg"
          src={this.state.language === "th" ? thaiFlag : thaiFlagGrey}
          value="th"
          onClick={() => {
            this.handleChange("th");
            this.setState({ languageStatus: "th" });
          }}
        />
        <img
          alt="eng-info"
          className="engImg"
          src={this.state.language === "en" ? engFlag : engFlagGrey}
          value="en"
          onClick={() => {
            this.handleChange("en");
            this.setState({ languageStatus: "en" });
          }}
        />
        <p className="thaiTextLang">ไทย</p>
        <p className="engTextLang">English</p>
        <Slide
          ref={this.slideRef}
          duration={properties.duration}
          autoplay={properties.autoplay}
          transitionDuration={properties.transitionDuration}
          arrows={properties.arrows}
          infinite={properties.infinite}
          easing={properties.easing}
          canSwipe={properties.canSwipe}
        >
          {slideImages.map((each, index) => (
            <div className="slide-container">
              <div key={index}>
                <img
                  className="lazy"
                  src={each}
                  alt="sample"
                  width={1280}
                  height={800}
                />
              </div>
            </div>
          ))}
        </Slide>
        <div className="shadow">
          <img className="shadowImg" src={shadow} alt="shadow" />
        </div>
        <img className="scanImg" src={scan} alt="scan-img" />
        <div className="bottom-centered">{t("scanWristBandHere")}</div>
        <div className="input-container">
          <input
            style={{
              opacity: "0",
              width: 0,
              height: 0,
            }}
            autoFocus={true}
            onKeyDown={this.handleWristbandKeyDown}
            ref={(inputEl) => (this.wristbandInput = inputEl)}
          />
          <p>{this.state.wristband}</p>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(App);
